"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('wallet', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("polygon", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(27.189532, 11.978915) rotate(60.000000) translate(-27.189532, -11.978915) ",
    points: "22.5771281 19.9478259 22.5771281 4.01000373 31.8019367 4.01000373"
  }), _react.default.createElement("path", {
    d: "M6,12 L42,12 C43.1045695,12 44,12.8954305 44,14 L44,42 C44,43.1045695 43.1045695,44 42,44 L6,44 C4.8954305,44 4,43.1045695 4,42 L4,14 C4,12.8954305 4.8954305,12 6,12 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M35.25,33 L44,33 L44,23 L35.25,23 C32.3505051,23 30,25.2385763 30,28 C30,30.7614237 32.3505051,33 35.25,33 Z",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M32,28.5 L56,28.5",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    transform: "translate(44.000000, 28.500000) rotate(90.000000) translate(-44.000000, -28.500000) "
  }))));
});

exports.default = _default;